<script setup lang="ts">
  const props = defineProps({
    canWrite: {
      type: Boolean,
      required: true
    }
  });

  const emit = defineEmits(['send']);

  const inputRef = ref<HTMLInputElement | null>(null);
  const value = ref('');

  const clear = () => {
    value.value = '';

    if (!inputRef.value) return;
    inputRef.value.focus();
  };

  const send = () => {
    if (!value.value || !props.canWrite) return;

    emit('send', value.value);
    clear();
  };

  onMounted(() => {
    if (!inputRef.value) return;
    inputRef.value.focus();
  });
</script>

<template>
  <div class="chat-input">
    <div class="chat-input__top">
      <div class="input-container">
        <label
          for="chatInput"
          class="hidden" />
        <input
          id="chatInput"
          ref="inputRef"
          v-model="value"
          name="chatInput"
          type="text"
          :disabled="!canWrite"
          :placeholder="$t('chat.input')"
          @keyup.enter.prevent.stop="send" />
      </div>
      <button
        v-if="value"
        @click.prevent.stop="clear" />
    </div>
    <div class="chat-input__bottom">
      <button
        tabindex="0"
        :disabled="!value || !canWrite"
        @click.prevent.stop="send">
        <span>{{ $t('chat.send') }}</span>
      </button>
    </div>
  </div>
</template>
